import * as React from "react";
import {createStyles, Grid, Theme, withStyles, WithStyles, withTheme, WithTheme} from "@material-ui/core";

const styles = (theme: Theme) => createStyles({
  titleBar: {
    color: theme.palette.text.secondary,
    flexGrow: 1,
    justifyContent: "space-between",
    width: "100%",
    padding: "4px 8px 0px 8px",
  },
  title: {
    justifyContent: "left",
    fontFamily: 'Archivo',
    fontSize: 20,
    fontWeight: 600,
    alignItems: "center",
    paddingTop: 0,
    lineHeight: 1.2,
  },
  actions: {
    justifyContent: "right",
    textAlign: "right",
    paddingTop: 4
  },
})

interface ITitleBarProps {
  title: string,
  className?: string
  children?: any
}

class TitleBar extends React.Component<WithStyles<typeof styles> & ITitleBarProps & WithTheme> {

  render() {
    const { classes, className, title, children } = this.props

    return (
      <Grid item className={className ? className : classes.titleBar}>
        <Grid container direction="row">
          <Grid item className={classes.title} xs={9}>
            {title}
          </Grid>
          <Grid item className={classes.actions} xs={3}>
            {children}
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

export default withTheme((withStyles(styles)(TitleBar)))
